import React, { Component } from "react"
import { connect } from "react-redux"

import { navigationPaths } from "../../constants/paths"

import Alert from "../../components/shared/Alert"
import ApplicationLayout from "../../layouts/ApplicationLayout"
import PaymentForm from "../../components/payments/PaymentForm"

class PaymentEdit extends Component {
  constructor(props) {
    super(props)

    this.state = {
      error: "",
      isSubmitting: false,
      payment: this.props.location.state.payment
    }
  }

  afterFormSubmit(status, data) {
    this.setState({ isSubmitting: false })

    if (status === "success") {
      this.onFormSubmitSuccess(data)
    } else {
      this.onFormSubmitFailure(data)
    }
  }

  onFormSubmit(formData) {
    this.setState({ isSubmitting: true })

    // this.props.dispatch({
    //   type: 'PAYMENT_CREATE_SAGA',
    //   payload: { formData: formData },
    //   callback: this.afterFormSubmit.bind(this)
    // })
  }

  onFormSubmitFailure(data) {
    this.setState({ error: data.error })
  }

  onFormSubmitSuccess(data) {
    this.props.history.push({
      pathname: navigationPaths.account(),
      state: data
    })
  }

  render() {
    const { error, isSubmitting, payment } = this.state

    return (
      <ApplicationLayout>
        <Alert message={error} type={"error"} visible={error !== ""} />

        <div>
          <div className={"dash-hd"}>EDIT PAYMENT</div>

          <PaymentForm
            isSubmitting={isSubmitting}
            onSubmit={this.onFormSubmit.bind(this)}
            payment={payment}
          />
        </div>
      </ApplicationLayout>
    )
  }
} // class PaymentEdit

export default connect()(PaymentEdit)
